import { ProgressBar } from '@servicetitan/anvil2';
import { Mask } from '@servicetitan/design-system';
import { FC, PropsWithChildren } from 'react';

interface BattlecardLoadingMaskProps {
    active: boolean;
}

export const BattlecardLoadingMask: FC<PropsWithChildren<BattlecardLoadingMaskProps>> = props => {
    return (
        <Mask
            {...props}
            content={<ProgressBar indeterminate label="Loading job details, hang tight!" />}
        />
    );
};
